<template>
  <div class="fastCheckConfirm full-height">
    <ld-header>
      订单信息填写
    </ld-header>

    <div>
      <!-- <div class="list">
        <span class="font16 font-bold">快速安检</span>
      </div> -->
      <div class="box">
        <van-field
          label="服务机场"
          placeholder="服务机场"
          :value="`${searchInfo.cityName} ${params.serverAirportName}`"
          readonly
        />
        <van-cell title="服务人数">
          <van-stepper v-model="personTime" />
        </van-cell>
        <van-field
          label="服务类型"
          placeholder="服务类型"
          v-model="params.leaveTypeName"
          readonly
        />
        <van-field
          label="航站楼"
          placeholder="航站楼"
          v-show="params.productType==1"
          v-model="params.terminalName"
          readonly
        />
      </div>
      <!--  -->
      <!-- <div class="box">
        <van-cell title="订单总额">
          <span class="money-color">￥{{ searchInfo.salePrice }}</span>
        </van-cell>
      </div> -->

      <trip-type
        is-switch
        :switch-title="tripType==1?'本次预订为因公预订':'本次预订为因私预订'"
        class="box"
      />

      <!-- 差旅信息 -->
      <travel-info
        class="box"
        v-show="tripType==1"
        ref="travelinfo"
        @selected="getTavelInfo"
        element=".fastCheckConfirm"
      />

      <!-- 联系信息 -->
      <van-field
        :label="$t('D022','联系信息')"
        :readonly="true"
        @click="$refs['linker'].toggle()"
      >
        <div slot="input">
          {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})
                
          <div class="font12 gray">
            {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
          </div>
        </div>
      </van-field>
    </div>

    <!--  -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow list"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
        gutter="16"
      >
        <van-col span="16">
          应付&nbsp;
          <span class="money-color font16">&yen; {{ (searchInfo.salePrice+searchInfo.serviceFee)*personTime }}</span>
        </van-col>
        <van-col
          span="8"
        >
          <ld-button
            main
            size="md"
            @click="book"
          >
            提交订单
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 编辑联系人 -->
    <ld-edit-linker
      ref="linker"
      :data="linker"
      @selected="getLinker"
    />
  </div>
</template>

<script>
import {Field,Cell,Stepper} from 'vant'
import { mapGetters } from 'vuex'
import tripType from 'Common/tripType'
import ldEditLinker from 'Components/ldEditLinker'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'
import { getName, getIdType, getIdNumber } from 'Utils/publicFun'

export default {
  name: 'GuestPassConfirm',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Stepper.name]: Stepper,
    ldEditLinker,
    ldTabbar,
    ldButton,
    travelInfo,
    tripType
  },
  data () {
    return {
      personTime:1,
      flightNo:'',
      departDate:'',
      showExpiryDate: false,
      expiryDate: new Date(),
      linker:{},
      travelInfo:{},
    }
  },
  computed: {
    ...mapGetters({
      tripType:'tripType',
      userInfo:'userInfo',
      travelerList: 'fastCheck/travelerList',
      searchInfo: 'fastCheck/searchInfo',
      params: 'fastCheck/params',
      sysType:'sysType'
    }),
  },
  created () {
    this.linker={
      linkEmail:this.userInfo.empInfo.email,
      linkMan:this.userInfo.empInfo.empName,
      linkTel:this.userInfo.empInfo.phoneNumber
    }
  },
  methods:{
    getTavelInfo(info) {// 获取差旅信息
      let obj={
        'projectId': '',
        'projectCode': '',
        'projectName': '',
        'ccsqdId': '',
        'ccsqdNo': '',
        'routeId': '',
        'costCenterId': '',
        'costCenterCode': '',
        'costCenterName': '',
        'violateitemCode': '',
        'violateitem': '',
        'reasonCode': '',
        'reasonDesc': '',
        'corpId': '',
        'corpCode': '',
        'corpName': '',
        'tripType': '',
        'ccsqdRemark': '',
        'subjectCode': '',
        'ifSameOrder': ''
      }
      for(let k in obj){
        if(info[k]){
          obj[k]=info[k]
        }
      }
      this.travelInfo=obj
    },
    book(){
      // if(this.travelerList.length==0){
      // 	this.$toast('请选择乘机人！')
      // 	return
      // }
      if(!this.linker.linkTel){
        this.$toast('联系人手机号不能为空！')
        return
      }
      if(this.tripType==1){
        let bl=this.$refs.travelinfo.result()//判断差旅信息是否填写完整 
        if(bl==false){
          return
        }
      }
      let psgList = this.travelerList.map((item,index) => {
        return {
          psgName: getName(item),
          psgType: item.psgType||'1',
          cardType: getIdType(item),//证件类型
          idNo: getIdNumber(item),//证件号码
          phoneNumber: item.phoneNumber,
          empId: item.conempId || item.empId
        }
      })
      this.$api['airService/bookOrder']({
        orderType:'11029',
        productId:this.searchInfo.id,
        seatType:this.params.seatType,
        personTime :this.personTime,//人次 
        flightDate:this.params.departDate,
        flightNo :this.searchInfo.flightNo ,
        deptCity  :this.searchInfo.departAirport,
        deptCityName:this.searchInfo.departCityName,
        arrCity :this.searchInfo.arriveAirport,
        arrCityName :this.searchInfo.arriveCityName,
        'psgBeanList': psgList,
        serverTime:'',
        serverType :this.params.leaveType,
        serverAirportCode:this.params.serverAirportCode,
        serverAirportName:this.params.serverAirportName,
        linkman :this.linker.linkMan,
        linkMobile:this.linker.linkTel ,
        linkEmail:this.linker.linkEmail ,
        tripType:this.tripType,
        'travelInfo' :this.travelInfo,
        orderFrom :this.sysType,
        relateOrder :this.params.relateOrder,//关联单号
      }).then(res=>{
        let cache=res.data||{}
        this.$router.push({path:'/fastCheck/order',query: { orderId:cache.orderId}})
      })
    },
    getLinker(info) {//修改联系人回调
      this.linker = {}
      this.linker = info
    },
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
</style>
